import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useSelector } from "react-redux";

function MoblieVertical({ product, onImageSelect }) {
  const [selectedImage, setSelectedImage] = useState(product?.image);
  const { configUrl } = useSelector((state) => state.cart);

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    onImageSelect(imageUrl);
  };

const settings = {
  slidesToScroll: 1,
  infinite: false,
  speed: 500,
  arrows: false,
  variableWidth: true,
  slideMargin: 12, 
};
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px",
    width:"100%"}}>
      <div style={{
        width: "100%",
        height: "300px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "8px",
        overflow: "hidden"
      }}>
        <img 
          src={selectedImage} 
          alt="Selected product" 
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain"
          }}
        />
      </div>

      <div style={{ }}>
  <Slider {...settings} style={{ width: "fit-content" }}>
    {product?.gallery?.map((image, index) => (
      <div
        key={index}
        style={{
          width: "27vw",
          padding: "5px",
          marginRight: "12px", // Increased from 4px to 12px for more gap
        }}
      >
        <img
          src={`${configUrl}${image.image}`}
          alt={image.alt || `Product view ${index}`}
          onClick={() => handleImageClick(`${configUrl}${image.image}`)}
          style={{
            width: "100%",
            height: "80px",
            objectFit: "contain",
            border:
              selectedImage === `${configUrl}${image.image}`
                ? "2px solid #2874f0"
                : "1px solid #e0e0e0",
            borderRadius: "4px",
            padding: "2px",
            cursor: "pointer",
            backgroundColor: "#fff",
          }}
        />
      </div>
    ))}
  </Slider>
</div>
    </div>
  );
}

export default MoblieVertical;